import { InformationAlertIcon } from "@images/svgIcons/informationAlertIcon"
import { useCurrentBox } from "@modules/box/useBox"
import { word } from "@modules/core/utils/i18n"
import { useFinanceSidebar } from "@modules/finances/hooks/useFinanceSidebar"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type FinanceFeesAlertCardProps = {} & React.HTMLAttributes<HTMLDivElement>

export const FinanceFeesAlertCard: React.FC<FinanceFeesAlertCardProps> = ({ ...props }) => {
  const defaultClassName = "card banner flex flex-row align-items-center px-4 py-3 gap-4"
  const theme = useTheme()
  const { navigateToFinanceFeesLayout } = useFinanceSidebar()
  const { result: boxId } = useCurrentBox()

  return (
    <div
      className={props.className ? props.className : defaultClassName}
      style={{ backgroundColor: theme.huCardAlertBackground }}
      {...props}
    >
      <div>
        <InformationAlertIcon
          backgroundColor={boxId ? theme.primaryColor100 : theme.primaryColor}
          color={boxId ? theme.primaryColor600 : theme.primaryColor900}
        />
      </div>
      <div className="flex flex-column">
        <HUText fontStyle="BL">{word("finance.fees.alertCard.title")}</HUText>
        <HUText fontStyle="BM">{word("finance.fees.alertCard.description")}</HUText>
        <HUButton
          text={word("finance.fees.alertCard.button")}
          className="w-min mt-3"
          onClick={navigateToFinanceFeesLayout}
          type="Right_Icon"
          size="M"
          colorType="Primary"
          fullWidth
        />
      </div>
    </div>
  )
}
